module.exports = __webpack_public_path__ + "66bb2cd68156060b5eb5dc3cd1caaa8c.webp";